import API from "../Network/API";

// Language and currency preferences survive logout; everything else (auth, checkout state) is cleared.
const KEEP_KEYS = ["i18nextLng", "xller_lang_chosen", "xller_geo_locale", "xller_currency"];

export const logout = (e) => {
    e?.preventDefault();
    API.post(`/v1/oauth/logout`).catch(() => {});
    try {
        const kept = KEEP_KEYS.map((key) => [key, localStorage.getItem(key)]);
        localStorage.clear();
        kept.forEach(([key, value]) => value !== null && localStorage.setItem(key, value));
    } catch (err) {}
    window.location.href = window.location.pathname.startsWith('/app') ? '/app' : '/';
}
